import React from "react";
import '../App.css'
import { Outlet, Link } from "react-router-dom";


function about() {
    return (
    <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-indigo-600 sm:text-5xl">About Us</h1>
        <p className="mt-6 text-base leading-7 text-gray-600">Upload a photo, then AI will roast the photo based on your appearance, any interesting features, even where the photo was taken.</p>
        <p className="mt-2 text-base leading-7 text-gray-600">You can then share with friends, post to 'Recent Roasts' or get a compliment instead.</p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Link
            to="/" 
            className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Go back home
          </Link>
        </div>
        <p className="mt-6 text-base leading-7 text-gray-600">Built by: nicomcgill@gmail.com</p>
      </div>
    </main>
    )
};

export default about